
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services/browse-service";
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components";
import {UserConfigService} from "@/services";


export default Vue.extend({
	data() {
		return {
			browse1: null as null | Browse,
			browse2: null as null | Browse,
			browse3: null as null | Browse,
			browse4: null as null | Browse,
			browse17: null as null | Browse,
			value1: 0,
			value2: 0,
			generalSettings: UserConfigService.getGeneralSettings(),
		};
	},
	computed: {
		items1(): ISelectItem<any>[] {
			let items = this.browse1?.Views.map(v => {
				return {value: v.ID, text: v.Name};
			});
			items?.unshift({value: 0, text: this.$ct("labels.none").toString()});
			return items || [];
		},
		items2(): ISelectItem<any>[] {
			let items = this.browse2?.Views.map(v => {
				return {value: v.ID, text: v.Name};
			});
			items?.unshift({value: 0, text: this.$ct("labels.none").toString()});
			return items || [];
		},
		items3(): ISelectItem<any>[] {
			let items = this.browse3?.Views.map(v => {
				return {value: v.ID, text: v.Name};
			});
			items?.unshift({value: 0, text: this.$ct("labels.none").toString()});
			return items || [];
		},
		items4(): ISelectItem<any>[] {
			let items = this.browse4?.Views.map(v => {
				return {value: v.ID, text: v.Name};
			});
			items?.unshift({value: 0, text: this.$ct("labels.none").toString()});
			return items || [];
		},
		items17(): ISelectItem<any>[] {
			let items = this.browse17?.Views.map(v => {
				return {value: v.ID, text: v.Name};
			});
			items?.unshift({value: 0, text: this.$ct("labels.none").toString()});
			return items || [];
		},
	},
	watch: {

	},
	methods: {
		onInputBrowse1(){},
		async save(){
			this.generalSettings = await UserConfigService.setGeneralSettings(this.generalSettings);
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		}
	},
	async created() {
		this.browse1 = (await BrowseService.getBrowse(4)).browse;
		this.browse2 = (await BrowseService.getBrowse(6)).browse;
		this.browse3 = (await BrowseService.getBrowse(9)).browse;
		this.browse4 = (await BrowseService.getBrowse(7)).browse;
		this.browse17 = (await BrowseService.getBrowse(17)).browse;
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.settings-browse"
	}
});
